// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Cfx_","right":"styles_right__1a-O6"};